import { IApplicationState } from '../../../types/redux';

/**
 * Возвращает состояние подписки
 */
export const listSubscribe = ({ listSubscribe }: IApplicationState) => listSubscribe;
